module.exports = require('events').EventEmitter;



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/stream-browserify/node_modules/readable-stream/lib/internal/streams/stream-browser.js